import { render, staticRenderFns } from "./Notiz.vue?vue&type=template&id=285fcd7e&"
import script from "./Notiz.vue?vue&type=script&lang=js&"
export * from "./Notiz.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports